// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ylC8","col":"styles_col__1eqWg"};